import { render, staticRenderFns } from "./FormHeader.vue?vue&type=template&id=3a25e638&scoped=true"
import script from "./FormHeader.vue?vue&type=script&lang=ts"
export * from "./FormHeader.vue?vue&type=script&lang=ts"
import style0 from "./FormHeader.vue?vue&type=style&index=0&id=3a25e638&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a25e638",
  null
  
)

export default component.exports